const tax_systems_translate = [
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [
        'Revente',
        'Pinel / Rés. principale'
    ],
]

const zones_translate = [
    ['Abis'],
    ['outre-mer'],
    ['A'],
    ['B1'],
    ['B2'],
    ['C'],
]


function getTaxSystemKochise(tax_system_plugimmo: string) {
    let tax;
    tax_systems_translate.forEach(function (sys, i) {
        if(sys.includes(tax_system_plugimmo)) {
            tax = i+1;
        }
    });
    return tax;
}


function getZoneKochise(zone: string) {
    let zoneT;
    zones_translate.forEach(function (sys, i) {
        if(sys.includes(zone)) {
            zoneT = i;
        }
    });
    return zoneT;
}



export { getTaxSystemKochise, getZoneKochise };
